export default [
  {
    title: "Reconciliation",
    icon: "FileTextIcon",
    tagVariant: "success",
    children: [
      {
        title: "Bank Statements",
        route: "BankStatements-View",
        resource: "Reconciliation",
        action: "View",
      },
      // {
      //   title: "Reconciliations",
      //   route: "Reconciliations-list",
      //   icon: "CircleIcon",
      //   resource: "Reconciliation",
      //   action: "View",
      // },
      {
        title: "UnMatched",
        route: "Reconciliations-unMatchedList",
        resource: "Reconciliation",
        action: "ViewUnMatched",
      },
      {
        title: "Unmatched Summary Report",
        route: "Reconciliations-UnmatchedSummaryReport",
        resource: "Reconciliation",
        action: "ViewUnmatchedSummaryReport",
      },
      {
        title: "Resolved Discrepancy Txn",
        route: "Reconciliations-ResolvedDiscrepancyTxn",
        resource: "Reconciliation",
        action: "ViewResolvedDiscrepancyTxn",
      },
      {
        title: "Matched",
        route: "Reconciliations-matchedList",
        resource: "Reconciliation",
        action: "ViewMatched",
      },
    ],
  },
];
